import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import LocalFormView from './DefaultView';

const LocalFormBlockView = (props) => {
  const { data, content, isEditMode, className, location } = props;
  return (
    <LocalFormView
      data={data}
      location={location}
      content={content}
      isEditMode={isEditMode}
      className={className}
    />
  );
};

export default withBlockExtensions(LocalFormBlockView);
